import { Card, CardTitle } from 'src/shared/components/ui'
import { CardContent } from 'src/shared/components/ui/card'
import { Input } from 'src/shared/components/ui'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { IconImage } from 'src/pages/Home/components/IconImage'
import { cn } from 'src/shared/components/ui/utils'
import { useHandleLogos } from 'src/shared/hooks/useHandleLogos'

interface CompanyProfileProps {
  workspaceName: string
  workspaceLogo: string | null
  organizationId: string | undefined
  companyUrl?: string
  onWorkspaceNameChange: (value: string) => void
  onWorkspaceLogoChange: (url: string | null) => void
}

export const CompanyProfile = ({
  workspaceName,
  workspaceLogo,
  organizationId,
  companyUrl,
  onWorkspaceNameChange,
  onWorkspaceLogoChange,
}: CompanyProfileProps) => {
  const { t } = useLocalization()
  const { uploadedLogos, brandfetchUrls: imgUrls } = useHandleLogos({
    org_id: organizationId,
    companyUrl: companyUrl,
    selectedLogoUrl: workspaceLogo,
    onLogoSelect: onWorkspaceLogoChange,
  })

  const hasLogoChoices = uploadedLogos.length > 0 || imgUrls.length > 0

  return (
    <Card>
      <CardContent className="p-6">
        <Column className="gap-6">
          <CardTitle className="text-lg">
            {t('Company profile', 'Företagsprofil')}
          </CardTitle>

          <Column className="gap-3">
            <label className="text-sm font-medium text-foreground">
              {t('Workspace logo', 'Arbetsyta-logotyp')}
            </label>

            {hasLogoChoices && (
              <Row className="items-center mt-2 gap-2 flex-wrap">
                {uploadedLogos.map((logo, index) => (
                  <Column
                    key={`uploaded-${logo.url}-${index}`}
                    className="h-full"
                  >
                    <IconImage
                      src={logo.url}
                      selected={workspaceLogo === logo.url}
                      onClick={() => onWorkspaceLogoChange(logo.url)}
                      className={cn('cursor-pointer h-[50px] w-full')}
                    />
                  </Column>
                ))}
                {imgUrls.map((url, index) => (
                  <Column key={`brandfetch-${url}-${index}`} className="h-full">
                    <IconImage
                      src={url}
                      selected={workspaceLogo === url}
                      onClick={() => onWorkspaceLogoChange(url)}
                      className={cn('cursor-pointer h-[50px] w-full')}
                    />
                  </Column>
                ))}
              </Row>
            )}
          </Column>

          <Input
            label={t('Workspace name', 'Arbetsyta-namn')}
            value={workspaceName}
            onChange={(e) => onWorkspaceNameChange(e.target.value)}
            placeholder={t('Enter workspace name', 'Ange arbetsyta-namn')}
            className="w-full"
          />
        </Column>
      </CardContent>
    </Card>
  )
}
